// Each open modal owns one history entry, so the phone's back button closes
// the modal instead of leaving the page.
//
// Entries are kept as a stack, one per pushed history entry, and each popstate
// closes only the top one. This used to be a single handler, replaced by every
// openModal: a modal opened on top of another (a review sheet over the booking
// form, an error over a picker) dropped the one underneath, whose entry was
// then popped without closing it.
//
// Each entry remembers the setter it was opened with. Many pages open their
// forms with plain state (or ?requestForm in the URL) instead of openModal,
// and the same form component is shared between both kinds of page, so
// closeModal and swapModal check the top entry before touching history.
const entries = [];
let isListening = false;

const onPopState = () => {
    const entry = entries.pop();
    if (entry) entry.setIsOpen(false);
}

const ensureListener = () => {
    if (isListening) return;
    window.addEventListener('popstate', onPopState, false);
    isListening = true;
}

const isOnTop = (setIsOpen) => entries.length > 0 && entries[entries.length - 1].setIsOpen === setIsOpen

export const dismissModal = () => {
    // Just navigate back - the popstate handler closes the top modal
    window.history.back();
}

export const openModal = (setIsModalOpen) => {
    ensureListener();
    setIsModalOpen(true);
    window.history.pushState(null, null, window.location.href);
    entries.push({ setIsOpen: setIsModalOpen });
}

// Close a modal however it was opened: pop its history entry when it owns
// the top one (so no stale entry is left for the back button), otherwise
// just hide it. Never navigates away from a page that opened the modal with
// plain state.
export const closeModal = (setIsModalOpen) => {
    if (isOnTop(setIsModalOpen)) {
        window.history.back();
    } else {
        setIsModalOpen(false);
    }
}

// Replace one modal with another, e.g. a service picker sheet handing over
// to the booking form. When the first one owns the top history entry, the
// second takes it over, so one back press closes the form. Otherwise this is
// a plain close + openModal.
export const swapModal = (setFromOpen, setToOpen) => {
    setFromOpen(false);
    if (!isOnTop(setFromOpen)) {
        openModal(setToOpen);
        return;
    }
    setToOpen(true);
    entries[entries.length - 1] = { setIsOpen: setToOpen };
}
